module.exports = __webpack_public_path__ + "static/img/luyin.b16b7f26.png";